import { render, staticRenderFns } from "./UserDropMenu.vue?vue&type=template&id=ff815a50&"
import script from "./UserDropMenu.vue?vue&type=script&lang=js&"
export * from "./UserDropMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserDropMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports